import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Dayjs } from 'dayjs';
import type { DayjsTransformReturn } from 'frontend-utils/transforms/dayjs';

export default class AiReply extends Model {
  [Type] = 'reviews/ai-reply' as const;

  @belongsTo('reviews/review', { async: false, inverse: 'aiReplies' })
  declare reviewId: string;
  @attr('string') declare externalId: string;
  @attr('dayjs') declare generatedAt: DayjsTransformReturn;
  @attr('string') declare generatedReply: string;
  @attr('dayjs') declare improvedAt: DayjsTransformReturn;
  @attr('string') declare improvedReply: string;
  @attr('string') declare languageCode: string;
  @attr('string') declare otaId: string;
  @attr('string') declare responseText: string;
  @attr('string') declare reviewText: string;

  get aiReplyTimestamp(): Dayjs {
    return (this.improvedAt || this.generatedAt)!;
  }
}
